module.exports = __webpack_public_path__ + "static/assets/815722a86a1c3bec87a955f9b0e61a78.png";